import { render, staticRenderFns } from "./AccueilEnfant.vue?vue&type=template&id=03d8f72c"
import script from "./AccueilEnfant.vue?vue&type=script&lang=js"
export * from "./AccueilEnfant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports